/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MentionConceptType } from '../model';
// @ts-ignore
import type { MentionSearchResponse } from '../model';
/**
 * MentionsApi - axios parameter creator
 */
export const MentionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Organization-scoped mention suggestions.  Returns the organization-resolvable concepts — policies, risk categories and organization users — scoped to the authenticated user\'s organization. Project-scoped concepts return no results here; use the project endpoint for those. Each concept requires its own organization read right (see ``authorize_organization_mention``). Searches by code and name, returning up to 10 results.
         * @summary Search Mentions
         * @param {MentionConceptType} conceptType 
         * @param {string | null} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMentions: async (conceptType: MentionConceptType, query?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conceptType' is not null or undefined
            assertParamExists('searchMentions', 'conceptType', conceptType)
            const localVarPath = `/mentions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (conceptType !== undefined) {
                localVarQueryParameter['concept_type'] = conceptType;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Project-scoped mention suggestions.  Returns the project\'s concepts plus the organization-level concepts reachable from it. Access requires project read rights; the project must be in the caller\'s organization (no cross-organization mentions); and organization-level concepts (policies, risk categories) additionally require their own organization read right. Users are the project\'s **active** members. Searches by code and name, returning up to 10 results.  User mentions go through the v2 ``MentionService`` so they can be scoped to active members. TRANSITIONAL: every other concept still delegates to the legacy ``ModulosAssistantMentionService`` — that service (and its non-v2 patterns) must stay until project-concept search is reimplemented natively in v2, so retiring the legacy ``/modulos-assistant`` route does not remove it.
         * @summary Search Project Mentions
         * @param {string} projectId 
         * @param {MentionConceptType} conceptType 
         * @param {string | null} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProjectMentions: async (projectId: string, conceptType: MentionConceptType, query?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('searchProjectMentions', 'projectId', projectId)
            // verify required parameter 'conceptType' is not null or undefined
            assertParamExists('searchProjectMentions', 'conceptType', conceptType)
            const localVarPath = `/mentions/projects/{project_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (conceptType !== undefined) {
                localVarQueryParameter['concept_type'] = conceptType;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MentionsApi - functional programming interface
 */
export const MentionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MentionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Organization-scoped mention suggestions.  Returns the organization-resolvable concepts — policies, risk categories and organization users — scoped to the authenticated user\'s organization. Project-scoped concepts return no results here; use the project endpoint for those. Each concept requires its own organization read right (see ``authorize_organization_mention``). Searches by code and name, returning up to 10 results.
         * @summary Search Mentions
         * @param {MentionConceptType} conceptType 
         * @param {string | null} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchMentions(conceptType: MentionConceptType, query?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MentionSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchMentions(conceptType, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MentionsApi.searchMentions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Project-scoped mention suggestions.  Returns the project\'s concepts plus the organization-level concepts reachable from it. Access requires project read rights; the project must be in the caller\'s organization (no cross-organization mentions); and organization-level concepts (policies, risk categories) additionally require their own organization read right. Users are the project\'s **active** members. Searches by code and name, returning up to 10 results.  User mentions go through the v2 ``MentionService`` so they can be scoped to active members. TRANSITIONAL: every other concept still delegates to the legacy ``ModulosAssistantMentionService`` — that service (and its non-v2 patterns) must stay until project-concept search is reimplemented natively in v2, so retiring the legacy ``/modulos-assistant`` route does not remove it.
         * @summary Search Project Mentions
         * @param {string} projectId 
         * @param {MentionConceptType} conceptType 
         * @param {string | null} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProjectMentions(projectId: string, conceptType: MentionConceptType, query?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MentionSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProjectMentions(projectId, conceptType, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MentionsApi.searchProjectMentions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MentionsApi - factory interface
 */
export const MentionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MentionsApiFp(configuration)
    return {
        /**
         * Organization-scoped mention suggestions.  Returns the organization-resolvable concepts — policies, risk categories and organization users — scoped to the authenticated user\'s organization. Project-scoped concepts return no results here; use the project endpoint for those. Each concept requires its own organization read right (see ``authorize_organization_mention``). Searches by code and name, returning up to 10 results.
         * @summary Search Mentions
         * @param {MentionsApiSearchMentionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMentions(requestParameters: MentionsApiSearchMentionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MentionSearchResponse> {
            return localVarFp.searchMentions(requestParameters.conceptType, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * Project-scoped mention suggestions.  Returns the project\'s concepts plus the organization-level concepts reachable from it. Access requires project read rights; the project must be in the caller\'s organization (no cross-organization mentions); and organization-level concepts (policies, risk categories) additionally require their own organization read right. Users are the project\'s **active** members. Searches by code and name, returning up to 10 results.  User mentions go through the v2 ``MentionService`` so they can be scoped to active members. TRANSITIONAL: every other concept still delegates to the legacy ``ModulosAssistantMentionService`` — that service (and its non-v2 patterns) must stay until project-concept search is reimplemented natively in v2, so retiring the legacy ``/modulos-assistant`` route does not remove it.
         * @summary Search Project Mentions
         * @param {MentionsApiSearchProjectMentionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProjectMentions(requestParameters: MentionsApiSearchProjectMentionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MentionSearchResponse> {
            return localVarFp.searchProjectMentions(requestParameters.projectId, requestParameters.conceptType, requestParameters.query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for searchMentions operation in MentionsApi.
 */
export interface MentionsApiSearchMentionsRequest {
    readonly conceptType: MentionConceptType

    readonly query?: string | null
}

/**
 * Request parameters for searchProjectMentions operation in MentionsApi.
 */
export interface MentionsApiSearchProjectMentionsRequest {
    readonly projectId: string

    readonly conceptType: MentionConceptType

    readonly query?: string | null
}

/**
 * MentionsApi - object-oriented interface
 */
export class MentionsApi extends BaseAPI {
    /**
     * Organization-scoped mention suggestions.  Returns the organization-resolvable concepts — policies, risk categories and organization users — scoped to the authenticated user\'s organization. Project-scoped concepts return no results here; use the project endpoint for those. Each concept requires its own organization read right (see ``authorize_organization_mention``). Searches by code and name, returning up to 10 results.
     * @summary Search Mentions
     * @param {MentionsApiSearchMentionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchMentions(requestParameters: MentionsApiSearchMentionsRequest, options?: RawAxiosRequestConfig) {
        return MentionsApiFp(this.configuration).searchMentions(requestParameters.conceptType, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Project-scoped mention suggestions.  Returns the project\'s concepts plus the organization-level concepts reachable from it. Access requires project read rights; the project must be in the caller\'s organization (no cross-organization mentions); and organization-level concepts (policies, risk categories) additionally require their own organization read right. Users are the project\'s **active** members. Searches by code and name, returning up to 10 results.  User mentions go through the v2 ``MentionService`` so they can be scoped to active members. TRANSITIONAL: every other concept still delegates to the legacy ``ModulosAssistantMentionService`` — that service (and its non-v2 patterns) must stay until project-concept search is reimplemented natively in v2, so retiring the legacy ``/modulos-assistant`` route does not remove it.
     * @summary Search Project Mentions
     * @param {MentionsApiSearchProjectMentionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchProjectMentions(requestParameters: MentionsApiSearchProjectMentionsRequest, options?: RawAxiosRequestConfig) {
        return MentionsApiFp(this.configuration).searchProjectMentions(requestParameters.projectId, requestParameters.conceptType, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }
}

